import { Directive, HostListener, Output, Input, EventEmitter, ElementRef, OnInit, OnDestroy } from '@angular/core';
import * as $ from 'jquery';

@Directive({
    selector: '[appScrollSpyMenu]'
})
export class ScrollSpyMenuDirective implements OnInit, OnDestroy {
    @Input() public spiedTags = [];
    @Input() public scrollOffset = 0;
    @Input() public local = false;
    @Output() public sectionChange = new EventEmitter<string>();
    private currentSection: string;

    constructor(private _el: ElementRef) { }

    ngOnInit() {
        $(document).on('scroll', (event) => this.onScroll(event));
    }

    ngOnDestroy() {
        $(document).off('scroll', (event) => this.onScroll(event));
    }

    @HostListener('scroll', ['$event'])
    onScroll(event: any) {
        let currentSection: string;
        const children = this._el.nativeElement.children;
        let scrollTop: number;
        if (this.local)
            scrollTop = this._el.nativeElement.scrollTop;
        else
            scrollTop = $('html').scrollTop();
        const parentOffset = this.scrollOffset;
        for (let i = 0; i < children.length; i++) {
            const element = children[i];
            if (this.spiedTags.some(spiedTag => spiedTag === element.tagName)) {
                if ((element.offsetTop - parentOffset) <= scrollTop) {
                    currentSection = element.id;
                }
            }
        }
        if (currentSection && currentSection !== this.currentSection) {
            this.currentSection = currentSection;
            this.sectionChange.emit(this.currentSection);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/directive/scroll-spy-menu.directive.ts